import React, { useEffect, useState } from 'react';
import { Badge, IconButton, Icon } from '@sumtotal/react-foundation';
import styled from 'styled-components';
import PropTypes, { checkPropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import useCustomNavigation from '../../hooks/useCustomNavigation';
import getCartItemsCount from '../services/shoppingCartService';
import getLogger from '../../../utils/logger';
import useUserContext from '../../hooks/useUserContext';
import useHeaderContext from '../../hooks/useHeaderContext';

const ShoppingCartButton = styled(IconButton)`
  color: ${(props) => props.theme.variables.headerBarColor};
  &.Mui-disabled {
    color: ${(props) => props.theme.variables.headerBarColor};
    opacity: 0.5;
  }
  &:focus {
    background-color: ${(props) => props.theme.variables.leftNavHeaderBackground};
    outline: -webkit-focus-ring-color auto 0.0625rem;
  }
`;

const BadgeIcon = styled(Badge)`
  display: flex;
  justify-content: center;
  & .MuiBadge-badge {
    height: 1rem;
    width: 1.2rem;
    min-width: 1.2rem;
    font-size: 0.7rem;
    font-weight: bold;
  }
  & .MuiBadge-colorPrimary {
    color: ${(props) => props.theme.variables.headerBarColor};
    border-color: ${(props) => props.theme.variables.headerBarColor};
  }
  & .MuiBadge-anchorOriginTopRightCircle {
    right: 1%;
    top: 1%;
  }
`;

function ShoppingCart(props) {
  const { shoppingCartMenu = defaultProps.shoppingCartMenu } = props;
  checkPropTypes(ShoppingCart.propTypes, props, 'prop', ShoppingCart.name);
  const { t } = useTranslation(['TRANSLATIONS_RCORE_TOPNAV']);
  const navigate = useCustomNavigation();
  const { user } = useUserContext();
  const disableShoppingCart = user.isEmulatedUser ? false : user.mustAnswerSecurityQuestions;
  const headerData = useHeaderContext();
  const { headerContext } = headerData;
  const [shoppingCartCount, setShoppingCartCount] = useState();
  useEffect(() => {
    if (shoppingCartMenu) {
      getCartItemsCount()
        .then((Count) => {
          setShoppingCartCount(Count);
          return Count;
        })
        .catch((err) => {
          getLogger().error(err);
        });
    }
  }, [shoppingCartMenu]);

  useEffect(() => {
    if (headerContext.cartItemsCount >= 0) {
      setShoppingCartCount(headerContext.cartItemsCount);
    }
  }, [headerContext.cartItemsCount]);

  const navigateToCart = () => {
    navigate(shoppingCartMenu.url);
  };

  if (shoppingCartMenu && shoppingCartCount > 0) {
    return (
      <ShoppingCartButton
        label={
          shoppingCartCount > 1
            ? t('RCORE_TOPNAV_SHOPPING_CART_ITEMS', { itemCount: shoppingCartCount })
            : t('RCORE_TOPNAV_SHOPPING_CART_ITEM', { itemCount: shoppingCartCount })
        }
        disabled={disableShoppingCart}
        onClick={navigateToCart}
      >
        <BadgeIcon
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'top'
          }}
          badgeContent={shoppingCartCount}
        >
          <Icon iconType="MaterialIcon" iconName="ShoppingCart" size={1.5} />
        </BadgeIcon>
      </ShoppingCartButton>
    );
  }
  return null;
}

// PropType check
ShoppingCart.propTypes = {
  /**
   * ShoppingCart Menu
   */
  shoppingCartMenu: PropTypes.oneOfType([PropTypes.object])
};

const defaultProps = {
  shoppingCartMenu: undefined
};

export default ShoppingCart;
